export default function Document(changeID) {
  this.documentID = null
  this.changeID = changeID
  this.description = ''
  this.fileName = ''
  this.created = ''
  this.file = ''
  this.mimeType = ''
}
